import { createContext } from "react";
import { HEADER_LEVELS } from "config/constants";

export const MicrodataContext = createContext(false);
export const HeaderContext = createContext(HEADER_LEVELS.STREAM_DEFAULT);
